// A drag pushes one snapshot per mousemove; undo-stack entries closer together than this are one gesture, so undo rewinds past the whole batch to the gesture's starting state.
export const UNDO_GESTURE_WINDOW_MS = 100;
